module.exports = __webpack_public_path__ + "img/si.cca3a43b.png";